/**
 * @generated SignedSource<<40ef0a513a9213ad6306777866eab82f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClipCutModal_meetingRecording$data = {
  readonly __typename: "MeetingRecording";
  readonly id: string;
  readonly meetingRecordedVideoDuration: number | null;
  readonly meetingRecordedVideoUrl: string | null;
  readonly note: {
    readonly title: string;
  } | null;
  readonly ownerAccount: {
    readonly __typename: string;
  };
  readonly subtitlesVttUrl: string;
  readonly thumbnailVttUrl: string | null;
  readonly transcript: any | null;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_Transcript_meetingRecording" | "TranscriptVideo_meetingRecording">;
  readonly " $fragmentType": "ClipCutModal_meetingRecording";
};
export type ClipCutModal_meetingRecording$key = {
  readonly " $data"?: ClipCutModal_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClipCutModal_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "public",
    "value": false
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClipCutModal_meetingRecording",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitlesVttUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailVttUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_Transcript_meetingRecording"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptVideo_meetingRecording"
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};
})();

(node as any).hash = "3a8074f83669ae6d0c9b443a6188a44a";

export default node;
